import IntroConversionModule from "./introConversionModule";
import IntroConversionSaga from "./redux/introConversionSagas";
import IntroConversionReducer from "./redux/introConversionReducer";

export default {
  Component: IntroConversionModule,
  moduleName: "introConversion",
  saga: IntroConversionSaga(),
  reducer: IntroConversionReducer
};
